import IncentivesMarketAdminPanel from 'modules/incentivesMarket/pages/IncentivesMarketAdminPanel';
import { IncentivesMarketAdminPanelProvider } from '../pages/IncentivesMarketAdminPanel/context/IncentivesMarketAdminPanelContext';

const IncentivesMarketAdminPanelContainer = () => (
  <IncentivesMarketAdminPanelProvider>
    <IncentivesMarketAdminPanel />
  </IncentivesMarketAdminPanelProvider>
);

export default IncentivesMarketAdminPanelContainer;
